const state = () => ({})

// getters
const getters = {}

// actions
const actions = {
    // add directory
    async add({state, commit}, {data}) {

        try {
            const res = await this._vm.axios.post(
                this._vm.endpoint.get('library_directory'),
                {
                    ...data
                }
            )

            return res.data
        } catch (error) {
            throw error.response?.data || error
        }
    },

    // update directory
    async update({state, commit}, {data}) {
        try {
            const res = await this._vm.axios.put(
                this._vm.endpoint.get('library_directory') + '/' + data.id,
                {
                    ...data
                }
            )

            return res.data
        } catch (error) {
            throw error.response?.data || error
        }
    },

    // delete directory
    async delete({state, commit}, {data}) {
        try {
            const res = await this._vm.axios.delete(
                this._vm.endpoint.get('library_directory') + '/' + data.id)

            return res.data
        } catch (error) {
            throw error.response?.data || error
        }
    },
}

// mutations
const mutations = {}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
